<script setup>
import { useLocalePath } from '#imports';

const localePath = useLocalePath();
const route = useRoute()
const router = useRouter()

const redirectTo = ref({})
watch(
    () => route.name,
    (newName) => {
        newName = newName.split('_')[0];
        if (['index', 'register', 'login'].includes(newName)) {
            redirectTo.value = { name: 'login', query: {redirect: route.query.redirect} }
        } else {
            redirectTo.value = { name: 'login', query: { redirect: route.path } }
        }
    },
    { immediate: true }
)

function navigate() {
    if (!redirectTo.value) {
        return;
    }
    router.push(localePath(redirectTo.value));
}
</script>

<template>
    <button
        class="nav-link nav-login has-dark"
        rel="nofollow"
        @click.prevent="navigate"
    >
        {{ $t('Account') }}
    </button>
</template>
